export const trialPlanOptions = {
    nb_social_profiles: 15,
    nb_users: 10
} as const;
